import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-currency.tsx
var TextInputCurrency = ({ children }) => {
	if (!children) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "currency",
		children
	});
};
//#endregion
export { TextInputCurrency };

//# sourceMappingURL=text-input-currency.js.map